// @flow strict
import loadAsync from 'routing/loadAsync';

const QueryInput = loadAsync(() => import('./QueryInput'));

export default QueryInput;
